import { z } from "zod";

export const metaSchema = z
  .object({
    toasts: z.object({
      error: z.string(),
      success: z.string(),
    }),
  })
  .deepPartial()
  .optional();

export type QueryMeta = z.infer<typeof metaSchema>;
